<template>
  <b-card
    class="video-details-video-displays"
    no-body
  >
    <b-card-header class="border-bottom mb-1">
      <b-card-title class="font-weight-bold text-secondary font-medium-3">
        <span>{{ vjData.title }}</span>
      </b-card-title>
    </b-card-header>
    <b-row class="match-height mx-1 font-medium-1 font-weight-bold text-dark mb-1">
      <b-col cols="12">
        {{ $t('Overall Details') }}
      </b-col>
    </b-row>
    <b-row class="match-height mx-1 font-medium-1">
      <b-col cols="4">
          {{ $t('Total Jump Count: ') }} {{ vjData.jumpCount.toLocaleString() }} ({{ vjData.jumpUserCount? vjData.jumpUserCount.toLocaleString() : 'n/a' }} users)
      </b-col>
      <b-col cols="4">
        {{ $t('Jumps Forward Count: ') }} {{ vjData.jumpForwardCount.toLocaleString() }}
      </b-col>
      <b-col cols="4">
        {{ $t('Jumps Backward Count: ') }} {{ vjData.jumpBackwardCount.toLocaleString() }}
      </b-col>
    </b-row>
    <b-row class="match-height mx-1 font-medium-1">
      <b-col cols="4">
        {{ $t('Jumps Range Total: ') }} {{ vjData.videoJumpRangeTotal }}
      </b-col>
      <b-col cols="4">
        {{ $t('Jumps Range Forward Total: ') }} {{ vjData.videoJumpRangeForwardTotal }}
      </b-col>
      <b-col cols="4">
        {{ $t('Jumps Range Backward Total: ') }} {{ vjData.videoJumpRangeBackwardTotal }}
      </b-col>
    </b-row>
    <b-row class="match-height mx-1 mt-2 font-medium-1 font-weight-bold text-dark border-top">
      <b-col
        cols="12"
        class="mb-1 mt-1"
      >
        {{ $t('Forward Jump Times Breakdown') }}
      </b-col>
      <b-col cols="4">
        {{ $t('Time') }}
      </b-col>
      <b-col cols="2">
        {{ $t('Jumps') }}
      </b-col>
    </b-row>
    <div class="mb-2">
      <b-row
          v-for="(item, index) in vjData.forwardJumpList"
          :key="`vd-item-${index}`"
          class="match-height font-medium-1 border-bottom p-3"
      >
        <b-col cols="4">
          {{ item.time }}
        </b-col>
        <b-col cols="2">
          {{ item.count.toLocaleString() }}
        </b-col>
        <!-- Row For Loop  Ends -->
      </b-row>
    </div>
    <b-row class="match-height mx-1 mt-2 font-medium-1 font-weight-bold text-dark border-top">
      <b-col
          cols="12"
          class="mb-1 mt-1"
      >
        {{ $t('Backward Jump Times Breakdown') }}
      </b-col>
      <b-col cols="4">
        {{ $t('Time') }}
      </b-col>
      <b-col cols="2">
        {{ $t('Jumps') }}
      </b-col>
    </b-row>
    <div class="mb-2">
      <b-row
          v-for="(item, index) in vjData.backwardJumpList"
          :key="`vd-item-${index}`"
          class="match-height font-medium-1 border-bottom p-3"
      >
        <b-col cols="4">
          {{ item.time }}
        </b-col>
        <b-col cols="2">
          {{ item.count.toLocaleString() }}
        </b-col>
        <!-- Row For Loop  Ends -->
      </b-row>
    </div>
  </b-card>
</template>

<script>
import {
    BRow, BCol, BCard, BCardTitle, BCardHeader, VBTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
    components: {
        BRow,
        BCol,
        BCard,
        BCardTitle,
        BCardHeader,
    },
    directives: {
        Ripple,
        'b-tooltip': VBTooltip,
    },
    props: {
        vjData: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {}
    },
}
</script>
